module.exports = __webpack_public_path__ + "img/cast_ic_data.395aa3ac.svg";